import React from 'react';
import LinkCell3 from "./LinkCell3/LinkCell3";

function ToMedCentersOrOrg(props) {

    const med_id = props.idArr[0]
    const org_id = props.idArr[1]

    switch (props.idArr[2]) {
        case "Организация":
            return <LinkCell3
                linkRoute={process.env.REACT_APP_URL_PREFIX + `/counterAgents/allOrgList/orgHistory/${org_id}/${props.cellContent}`}
                linkTitle={props.cellContent}
                editClick={_ => props.cellData.onClick(med_id || org_id)}/>
        case "Медцентр":
            return <LinkCell3
                linkRoute={process.env.REACT_APP_URL_PREFIX + `/counterAgents/MedCenterOrgList/${med_id}/${props.cellContent}`}
                linkTitle={props.cellContent}
                editClick={_ => props.cellData.onClick(med_id || org_id)}/>

    }
}

export default ToMedCentersOrOrg;